import PropertyTypeActions from '../actions/propertyType';

const initialState = {
    additionalPropertyType: null
};

export default (state = initialState, action) => {
    switch (action.type) {
    case PropertyTypeActions.CLEAR_ADDITIONAL_PROPERTY_TYPE:
        return { ...state, additionalPropertyType: null };
    case PropertyTypeActions.SET_ADDITIONAL_PROPERTY_TYPE:
        return { ...state, additionalPropertyType: action.propertyType };
    default:
        return state;
    }
};
